import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const Account = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    color = '#0F0A1B',
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox='0 0 24 24'
      fill='none'
    >
      <circle cx='12' cy='8' r='5' stroke={color} strokeWidth='3' strokeLinecap='round' />
      <path fillRule='evenodd' clipRule='evenodd' d='M17.4347 11.5674C17.744 11.7796 18.0396 12.0143 18.3195 12.272C20.0295 13.8469 21 16.1456 21 19.0004V21.0004C21 21.8288 20.3284 22.5004 19.5 22.5004C18.6716 22.5004 18 21.8288 18 21.0004V19.0004C18 16.8551 17.2915 15.4038 16.2871 14.4787C15.9531 14.1711 15.5703 13.907 15.1443 13.6906C16.0691 13.1785 16.8559 12.4474 17.4347 11.5674ZM8.85573 13.6906C7.93088 13.1785 7.14409 12.4474 6.56531 11.5674C6.25604 11.7796 5.96039 12.0143 5.68052 12.272C3.97048 13.8469 3 16.1456 3 19.0004V21.0004C3 21.8288 3.67157 22.5004 4.5 22.5004C5.32843 22.5004 6 21.8288 6 21.0004V19.0004C6 16.8551 6.70845 15.4038 7.71288 14.4787C8.04687 14.1711 8.42975 13.907 8.85573 13.6906Z' fill={color} />
    </svg>
  );
});

Account.displayName = 'Account';
